<template>
  <div id="player-training-load-table">
    <v-data-table
      :headers="tableHeaders"
      :loading="loading"
      :items="stats"
      hide-default-footer
      :items-per-page="pagination.per_page"
      dense
    >
      <!--<editor-fold desc="ITEM SLOT">-->
      <template v-slot:item="{ item }">
        <player-training-load-table-row
          :data="item"
          :max-values="maxValues"
          :show-menstrual-period="showMenstrualPeriod"
          :show-wellness-data="showWellnessData"
          :player="player"
        />
      </template>
      <!--</editor-fold>-->
      <!--<editor-fold desc="LOADING SLOT">-->
      <template slot="loading">
        <div
          class="pa-5 d-flex justify-center align-center"
          :style="'min-height: ' + (stats.length * 49)+'px'"
        >
          <v-progress-circular
            indeterminate
            size="48"
            width="4"
            color="grey lighten-2"
          />
        </div>
      </template>
      <!--</editor-fold>-->
      <!--<editor-fold desc="PROGRESS SLOT">-->
      <template slot="progress">
        <!-- override default progress bar -->
        <div />
      </template>
      <!--</editor-fold>-->
    </v-data-table>
    <div
      v-if="pagination && pagination.last_page && pagination.last_page > 1"
      class="d-flex justify-center align-center py-5"
    >
      <pagination
        v-model="pagination.current_page"
        :last-page="pagination.last_page"
      />
    </div>
  </div>
</template>

<script>
import PlayerTrainingLoadTableRow from '@/components/players/PlayerTrainingLoadTableRow.vue'
import Pagination from '@/components/Pagination'

export default {
  name: 'PlayerTrainingLoadTable',
  components: { Pagination, PlayerTrainingLoadTableRow },
  props: {
    stats: {
      type: Array,
      required: true
    },
    loading: {
      type: Boolean,
      default: false
    },
    pagination: {
      type: Object,
      default: () => ({})
    },
    maxValues: {
      type: Object,
      default: () => ({})
    },
    showMenstrualPeriod: {
      type: Boolean,
      default: false
    },
    showWellnessData: {
      type: Boolean,
      default: false
    },
    player: {
      type: Object,
      default: () => ({})
    }
  },
  computed: {
    tableHeaders() {
      const headers = [
        { key: 'date', align: 'start', text: this.$t('picker.date.title'), sortable: false },
        { key: 'acwr', text: this.$t('table_headers.player_overview.acwr'), sortable: false },
        ...(this.$can('view-event-feedback') ? [{ key: 'TL', text: this.$t('table_headers.individual_load.tl'), sortable: false }] : []),
        { key: 'dayLoad', width: '90px', text: this.$t('table_headers.individual_load.dl'), sortable: false },
        { key: 'acuteLoad', width: '90px', text: this.$t('table_headers.individual_load.al'), sortable: false },
        { key: 'TL_CL', width: '90px', text: this.$t('table_headers.individual_load.cl'), sortable: false },
        { key: 'TL_WL', text: this.$t('table_headers.individual_load.total_wl'), sortable: false },
        { key: 'TL_WC', width: '110px', text: this.$t('table_headers.individual_load.wl_change'), sortable: false },
        { key: 'freshness', text: this.$t('table_headers.main_load.freshness'), sortable: false },
        { key: 'monotony', text: this.$t('table_headers.weekly_load.monotony'), sortable: false },
        ...(this.showWellnessData ? [{ key: 'strain', width: '90px', text: this.$t('table_headers.weekly_load.strain'), sortable: false }] : []),
        ...(this.showWellnessData ? [{ key: 'muscleSoreness', width: '1%', text: this.$t('table_headers.main_load.muscle_soreness'), sortable: false }] : []),
        ...(this.showWellnessData ? [{ key: 'stress', width: '1%', text: this.$t('table_headers.main_load.stress'), sortable: false }] : []),
        ...(this.showWellnessData ? [{ key: 'sleepStatus', width: '1%', align: 'start', text: this.$t('table_headers.main_load.sleep'), sortable: false }] : []),
        ...(this.showWellnessData ? [{ key: 'moodStatus', width: '1%', align: 'start', text: this.$t('table_headers.main_load.mood'), sortable: false }] : []),
        { key: 'pain', width: '1%', align: 'start', text: this.$t('table_headers.main_load.pain'), sortable: false },
        { key: 'sickness', width: '1%', align: 'start', text: this.$t('table_headers.main_load.sickness'), sortable: false }
      ]

      if (this.showMenstrualPeriod) {
        headers.push({ value: 'FMENSACT', text: this.$t('table_headers.individual_load.menstrual_period') })
        headers.push({ value: 'cycle_phase', text: this.$t('table_headers.individual_load.menstrual_cycle_phase') })
      }

      return headers
    }
  }
}
</script>
